import React, {useEffect,useState,useContext} from 'react'
import { GlobalContext } from '../contexts/GlobalContext';
import { useLocation,useParams, useNavigate } from 'react-router-dom';
import { PiArrowCircleLeftLight, PiGearLight, PiPath, PiPathLight, PiShapesLight, PiTrash } from 'react-icons/pi';
import client from '../client';
import AddCriteriaPathItem from './AddCriteriaPathItem';
import { createDialog,QuestionDialog,ContentGroup,ListItem,ContentContainer,Detail } from 'coaz-ui';


const CriteriaPath = () => {
	const {version,setVersion} = useContext(GlobalContext);
	const [criteriaPathItem,setCriteriaPathItem] = useState(null);
	const [children,setChildren] = useState([]);
	const [buttons,setButtons] = useState([]);
	const [itemButtons,setItemButtons] = useState(null);
	const [loading,setLoading] = useState(false);
	const {request,getCurrent,errorMessage} = client;
	const {pathId} = useParams();
	const path = useLocation().pathname;

	const navigate = useNavigate();

	const onOpen = (item) => {
        if(!item || !item.id)return;
        navigate(`/_paths/_path/${item.id}`)
    }

	const onAddChild = (e) => {
		e.preventDefault();
		createDialog({
            title:"Add Criteria Path Item",
            Component:AddCriteriaPathItem,
			params:{parentId:pathId},
            version:version,
            setVersion:setVersion
        })
	}

	const handleDelete = (item) => {
        if(!item) return;
        createDialog({
            title:'Delete Criteria Path Item',
            params:{
                submit:async (e) => {
                        try {
                            await request('DELETE',`criteriapathitems/${item.id}`)
                            return {
                                message: 'Successful',
                                success: true
                            };
                        } catch (error) {
                            return {
                                message: errorMessage(error)
                            };
                        }
                    },
                message:`Are you sure you want to delete ${item.text}? all children of this path will be deleted!`
            },
            Component:QuestionDialog,
            version:version,
            setVersion:setVersion
        })
    }

	const getCriteriaPathItem = async () => {
		const current = await getCurrent();

		if(!current) return;

		let createAuth = current.authorities.find((auth) => {return auth.authority === 'CRITERIA_PATH_ITEM:CREATE'});
		let deleteAuth = current.authorities.find((auth) => {return auth.authority === 'CRITERIA_PATH_ITEM:DELETE'});

		if(pathId) {
			await request('GET',`criteriapathitems/${pathId}`)
			.then((response) => {
				if(response && response.id) {
					setCriteriaPathItem(response);
					let btns = [];
					if(createAuth) {
						btns.push(
							{
								Icon:PiPath,
								name:'Add Child',
								handler:onAddChild
							}
						);
					}
					setButtons(btns);

					if(deleteAuth) {
						setItemButtons([
							{
								name:'Delete',
								Icon:PiTrash,
								handler:handleDelete
							}
						])
					}
				}  else {
					setCriteriaPathItem(null);
				}
			})
			.catch((error) => {
				setCriteriaPathItem(null);
			})
		}
	}

	const getChildren = async () => {
		if(pathId) {
			await request('GET','criteriapathitems/by-parent',null,{parentId:pathId})
			.then((response) => {
				if(response && response.length > 0) {
					setChildren(response);
				} else {
					setChildren([]);
				}
			})
			.catch((error) => {
				setChildren([]);
			})
		}
	}

	const load = async () => {
		!loading && setLoading(true);
		await getCriteriaPathItem();
		await getChildren();
		setLoading(false);
	}

	useEffect(() => {
		load();
	},[path,version])

  return (
	<div className='flex flex-col items-center w-full h-full pb-8 space-y-8 overflow-hidden'>
		<ContentContainer buttons={buttons} 
            Icon={PiPathLight} 
            text={criteriaPathItem?criteriaPathItem.name:''} 
			background={true}
			scrollable={true}
            loading={loading}> 
			{criteriaPathItem && 
				<div className='flex flex-col w-full h-auto space-y-4'>
					<div className='flex flex-col w-full h-auto space-y-2'>
						<Detail Icon={PiPathLight} label='Name' value={criteriaPathItem.name?criteriaPathItem.name:''}/>
						<Detail Icon={PiShapesLight} label='Type' value={criteriaPathItem.type?criteriaPathItem.type:''}/>
						<Detail Icon={PiShapesLight} label='Class Name' value={criteriaPathItem.className?criteriaPathItem.className:''}/>
						{criteriaPathItem.getMethod && 
							<Detail Icon={PiGearLight} label='method' value={criteriaPathItem.getMethod}/>
						}
						{criteriaPathItem.parent && 
							<Detail Icon={PiArrowCircleLeftLight} label='Parent' value={criteriaPathItem.parent.name}/>
						}
					</div>
					{children && children.length > 0 &&
					<ContentGroup name='Children'>
                        {children.map((child,i) => <ListItem 
							key={i} 
							Icon={PiPathLight} 
							item={{id:child.id,text:child.name}} 
							buttons={itemButtons}
							handleOpen={onOpen}
						/>)}
                    </ContentGroup>
					}
				</div>
			}
        </ContentContainer>
	</div>
  )
}

export default CriteriaPath

